import { useState, useEffect } from 'react'

/**
 * Hook to detect window size
 * Returns the current window width and height
 */
export function useWindowSize(): { width: number; height: number } {
  const [windowSize, setWindowSize] = useState(() => {
    if (typeof window !== 'undefined') {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      }
    }
    return {
      width: 1200, // Default width
      height: 800, // Default height
    }
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener('resize', handleResize)
    
    // Call once to set initial size
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return windowSize
}






